export function getCheckEndMeetingPrompt(message: string) {
  return `
Analyze the following message and determine if it indicates an attempt to end the call or say goodbye. If the message expresses a clear intention to conclude the conversation, respond with 'true'. Otherwise, respond with 'false' and explain why.

<MESSAGE>
${message}
</MESSAGE>
  `;
}

export function getCheckEndMeetingFunctions() {
  return [
    {
      name: 'analyze_message_and_determine_if_call_is_ending',
      description:
        "Analyze the following message and determine if it indicates an attempt to end the call or say goodbye. If the message expresses a clear intention to conclude the conversation, respond with 'true'. Otherwise, respond with 'false'.",
      parameters: {
        type: 'object',
        properties: {
          isEnding: {
            type: 'boolean',
            description: 'True if the message indicates an attempt to end the call, false otherwise.',
          },
          explanation: {
            type: 'string',
            description: 'A brief explanation for the decision.',
          },
        },
      },
    },
  ];
}
